import React, {
    RefObject,
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react";
import LayoutSettingsTabs from "components/QuotesLayoutSettings/LayoutSettingsTabs";
import { LayoutSideDropdown } from "./tabsLayoutDropdownStyles";
import { useClickOutside } from "hooks/useClickOutside";

export interface IProps {
    isOpen: boolean;
    ref: RefObject<HTMLDivElement>;
    wrapperRef: RefObject<HTMLDivElement>;
    closeHandler: () => void;
}

const TabsLayoutDropdown = forwardRef<HTMLDivElement, IProps>(
    ({ isOpen, wrapperRef, closeHandler }, ref) => {
        const localRef = useRef<HTMLDivElement>(null);
        useImperativeHandle(ref, () => localRef.current!);
        useClickOutside(isOpen, localRef, closeHandler);
        useClickOutside(isOpen, wrapperRef, closeHandler);

        return (
            <div ref={ref}>
                <LayoutSideDropdown dropTitle={"Настройки секций"}>
                    <LayoutSettingsTabs />
                </LayoutSideDropdown>
            </div>
        );
    }
);

export default TabsLayoutDropdown;
